// import {GET} from "ith-fetch";
import {GET} from "../Logic/fetch";
import {toISO} from "../Logic/Moment";

export const controlCall__get = (date) => GET(`/control` + (date ? `/${toISO(date)}` : ''));